import { Form, SelectField, SubmitButton, TextInputField } from '@/components';
import {
  FundBusinessCreateFormSchema,
  FundBusinessFormTitleModifier,
  fundBusinessForm,
} from '@/features/project/projects/detail/fund-bussiness/_model/fund-business';
import { useForm } from '@/hooks';
import { zodResolver } from '@hookform/resolvers/zod';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import type { z } from 'zod';

type FormValues = z.infer<typeof FundBusinessCreateFormSchema>;

type Props = {
  initialValues?: Partial<FormValues>;
  onSubmit: (values: FormValues) => void;
};

export const CreateFundBusinessForm: FC<Props> = ({
  initialValues,
  onSubmit,
}) => {
  const { t } = useTranslation();
  const {
    control,
    handleSubmit,
    formState: { errors, isSubmitting, isDirty, isSubmitSuccessful },
  } = useForm<FormValues>({
    defaultValues: initialValues,
    resolver: zodResolver(FundBusinessCreateFormSchema),
  });

  return (
    <Form
      leavePageAlertCondition={{
        isDirty,
        isSubmitting,
        isSubmitSuccessful,
      }}
      layout="vertical"
      onFinish={handleSubmit(onSubmit)}
    >
      <SelectField
        control={control}
        required
        label={t('type')}
        errors={errors}
        name="businessForm"
        disabled={!!initialValues?.businessForm}
        options={fundBusinessForm.options.map((value) => ({
          value,
          label: FundBusinessFormTitleModifier[value],
        }))}
      />
      <TextInputField
        control={control}
        label={t('fund-business-title')}
        errors={errors}
        name="title"
        autocompleteKey="fundBusiness.title"
      />
      <SubmitButton
        loading={isSubmitting}
        disabled={initialValues?.businessForm ? false : !isDirty}
      />
    </Form>
  );
};
